import React from 'react';
import styled from 'styled-components';
import {
    TeamOutlined,
    CalendarOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    DollarCircleOutlined,
} from '@ant-design/icons';

const KPIContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

const KPICard = styled.div`
  background: white;
  padding: 16px 20px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const KPIIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background-color: ${props => props.bgColor || '#e6f7ff'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: ${props => props.color || '#1890ff'};
`;

const KPIData = styled.div`
  display: flex;
  flex-direction: column;
`;

const KPINumber = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #1e90ff;
  line-height: 1;
`;

const KPILabel = styled.span`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
`;

const SubLabel = styled.span`
  font-size: 10px;
  color: #94a3b8;
  margin-left: 4px;
`;

const KPICards = ({ data, formatNumber }) => {
    return (
        <KPIContainer>
            <KPICard>
                <KPIIcon bgColor="#e6f4ff" color="#00c2ff">
                    <TeamOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber>{formatNumber(data?.kpi?.activeSpecialists)}</KPINumber>
                    <KPILabel>Especialistas <SubLabel>(Activos)</SubLabel></KPILabel>
                </KPIData>
            </KPICard>

            <KPICard>
                <KPIIcon bgColor="#e6f4ff" color="#00c2ff">
                    <TeamOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber>{formatNumber(data?.kpi?.activePatients)}</KPINumber>
                    <KPILabel>Pacientes <SubLabel>(Registrados)</SubLabel></KPILabel>
                </KPIData>
            </KPICard>

            <KPICard>
                <KPIIcon bgColor="#e6f4ff" color="#00c2ff">
                    <CalendarOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber>{data?.kpi?.appointmentsInRange || data?.kpi?.totalAppointments || 0}</KPINumber>
                    <KPILabel>Total Citas <SubLabel>(Periodo)</SubLabel></KPILabel>
                </KPIData>
            </KPICard>

            <KPICard>
                <KPIIcon bgColor="#e6f4ff" color="#00c2ff">
                    <CheckCircleOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber>{data?.kpi?.confirmedAppointments || 0}</KPINumber>
                    <KPILabel>Citas <SubLabel>(Confirmadas)</SubLabel></KPILabel>
                </KPIData>
            </KPICard>

            <KPICard>
                <KPIIcon bgColor="#eef2f6" color="#64748b">
                    <CloseCircleOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber style={{ color: '#64748b' }}>{data?.kpi?.cancelledAppointments || 0}</KPINumber>
                    <KPILabel>Citas <SubLabel>(Canceladas)</SubLabel></KPILabel>
                </KPIData>
            </KPICard>

            <KPICard>
                <KPIIcon bgColor="#e6fffb" color="#13c2c2">
                    <DollarCircleOutlined />
                </KPIIcon>
                <KPIData>
                    <KPINumber style={{ color: '#13c2c2' }}>${formatNumber(data?.kpi?.totalIncome || 0)}</KPINumber>
                    <KPILabel>Ingresos del periodo</KPILabel>
                </KPIData>
            </KPICard>
        </KPIContainer>
    );
};

export default KPICards;
